import { letters, status, letters_eng_srb } from './constants'
import { useEffect, useState } from 'react'

import { EndGameModal } from './components/EndGameModal'
import { ReactComponent as Info } from './data/Info.svg'
import { InfoModal } from './components/InfoModal'
import { Keyboard } from './components/Keyboard'
import { ReactComponent as Settings } from './data/Settings.svg'
import { SettingsModal } from './components/SettingsModal'
import Confetti from 'react-dom-confetti';
import answers from './data/answers'
import { useLocalStorage } from './hooks/useLocalStorage'
import words from './data/words'
import logo from './data/logo.png'
import { isMobile } from 'react-device-detect';

const state = {
  playing: 'playing',
  won: 'won',
  lost: 'lost',
}

const shareState = {
  notclicked: 'notclicked',
  clicked: 'clicked',
}

const confettiConfig = {
  angle: 90,
  spread: 180,
  startVelocity: 60,
  elementCount: 70,
  dragFriction: 0.12,
  duration: 2500,
  stagger: 3,
  width: "20px",
  height: "20px",
  perspective: "500px",
  colors: ["#63AA55", "#EAB308"]
};



const getRandomAnswer = () => {

  const date = getTodaysDate();

  var text = '';

if(date == '16/9/2024'){
  text = 'кавез';


  } else if (date == '1/4/2026') {
    text = 'немир';
  } else if (date == '2/4/2026') {
    text = 'жетва';
  } else if (date == '3/4/2026') {
    text = 'мерак';
  } else if (date == '4/4/2026') {
    text = 'шерпа';
  } else if (date == '5/4/2026') {
    text = 'ручка';
  } else if (date == '6/4/2026') {
    text = 'хитац';
  } else if (date == '7/4/2026') {
    text = 'пулпа';
  } else if (date == '8/4/2026') {
    text = 'какао';
  } else if (date == '9/4/2026') {
    text = 'хвала';
  } else if (date == '10/4/2026') {
    text = 'штанд';
  } else if (date == '11/4/2026') {
    text = 'мајка';
  } else if (date == '12/4/2026') {
    text = 'локал';
  } else if (date == '13/4/2026') {
    text = 'љубав';
  } else if (date == '14/4/2026') {
    text = 'фишек';
  } else if (date == '15/4/2026') {
    text = 'купка';
  } else if (date == '16/4/2026') {
    text = 'логор';
  } else if (date == '17/4/2026') {
    text = 'чесма';
  } else if (date == '18/4/2026') {
    text = 'нарав';
  } else if (date == '19/4/2026') {
    text = 'чаура';
  } else if (date == '20/4/2026') {
    text = 'мотив';
  } else if (date == '21/4/2026') {
    text = 'шофер';
  } else if (date == '22/4/2026') {
    text = 'ћерка';
  } else if (date == '23/4/2026') {
    text = 'лисац';
  } else if (date == '24/4/2026') {
    text = 'хорор';
  } else if (date == '25/4/2026') {
    text = 'кегла';
  } else if (date == '26/4/2026') {
    text = 'јетра';
  } else if (date == '27/4/2026') {
    text = 'зрнце';
  } else if (date == '28/4/2026') {
    text = 'софра';
  } else if (date == '29/4/2026') {
    text = 'прича';
  } else if (date == '30/4/2026') {
    text = 'смена';
  } else if (date == '1/5/2026') {
    text = 'флерт';
  } else if (date == '2/5/2026') {
    text = 'чорба';
  } else if (date == '3/5/2026') {
    text = 'нужда';
  } else if (date == '4/5/2026') {
    text = 'берза';
  } else if (date == '5/5/2026') {
    text = 'нерад';
  } else if (date == '6/5/2026') {
    text = 'корпа';
  } else if (date == '7/5/2026') {
    text = 'цртач';
  } else if (date == '8/5/2026') {
    text = 'скија';
  } else if (date == '9/5/2026') {
    text = 'купац';
  } else if (date == '10/5/2026') {
    text = 'клима';
  } else if (date == '11/5/2026') {
    text = 'мржња';
  } else if (date == '12/5/2026') {
    text = 'маска';
  } else if (date == '13/5/2026') {
    text = 'челик';
  } else if (date == '14/5/2026') {
    text = 'шурак';
  } else if (date == '15/5/2026') {
    text = 'тесто';
  } else if (date == '16/5/2026') {
    text = 'кабал';
  } else if (date == '17/5/2026') {
    text = 'рагби';
  } else if (date == '18/5/2026') {
    text = 'одмор';
  } else if (date == '19/5/2026') {
    text = 'казна';
  } else if (date == '20/5/2026') {
    text = 'дабар';
  } else if (date == '21/5/2026') {
    text = 'акреп';
  } else if (date == '22/5/2026') {
    text = 'румба';
  } else if (date == '23/5/2026') {
    text = 'текст';
  } else if (date == '24/5/2026') {
    text = 'чабар';
  } else if (date == '25/5/2026') {
    text = 'јутро';
  } else if (date == '26/5/2026') {
    text = 'ислам';
  } else if (date == '27/5/2026') {
    text = 'утока';
  } else if (date == '28/5/2026') {
    text = 'ражањ';
  } else if (date == '29/5/2026') {
    text = 'кљусе';
  } else if (date == '30/5/2026') {
    text = 'хауба';
  } else if (date == '31/5/2026') {
    text = 'оруђе';
  } else if (date == '1/6/2026') {
    text = 'цивил';
  } else if (date == '2/6/2026') {
    text = 'тацна';
  } else if (date == '3/6/2026') {
    text = 'праља';
  } else if (date == '4/6/2026') {
    text = 'књига';
  } else if (date == '5/6/2026') {
    text = 'замка';
  } else if (date == '6/6/2026') {
    text = 'летач';
  } else if (date == '7/6/2026') {
    text = 'расол';
  } else if (date == '8/6/2026') {
    text = 'мозак';
  } else if (date == '9/6/2026') {
    text = 'април';
  } else if (date == '10/6/2026') {
    text = 'октет';
  } else if (date == '11/6/2026') {
    text = 'могул';
  } else if (date == '12/6/2026') {
    text = 'метак';
  } else if (date == '13/6/2026') {
    text = 'жабар';
  } else if (date == '14/6/2026') {
    text = 'ораси';
  } else if (date == '15/6/2026') {
    text = 'школа';
  } else if (date == '16/6/2026') {
    text = 'литар';
  } else if (date == '17/6/2026') {
    text = 'ручак';
  } else if (date == '18/6/2026') {
    text = 'канџа';
  } else if (date == '19/6/2026') {
    text = 'рерна';
  } else if (date == '20/6/2026') {
    text = 'цимет';
  } else if (date == '21/6/2026') {
    text = 'ривал';
  } else if (date == '22/6/2026') {
    text = 'мерач';
  } else if (date == '23/6/2026') {
    text = 'летва';
  } else if (date == '24/6/2026') {
    text = 'пакао';
  } else if (date == '25/6/2026') {
    text = 'шанса';
  } else if (date == '26/6/2026') {
    text = 'пегла';
  } else if (date == '27/6/2026') {
    text = 'одлив';
  } else if (date == '28/6/2026') {
    text = 'сурла';
  } else if (date == '29/6/2026') {
    text = 'мачка';
  } else if (date == '30/6/2026') {
    text = 'роман';
  } else if (date == '1/7/2026') {
    text = 'парче';
  } else if (date == '2/7/2026') {
    text = 'строј';
  } else if (date == '3/7/2026') {
    text = 'тиква';
  } else if (date == '4/7/2026') {
    text = 'листа';
  } else if (date == '5/7/2026') {
    text = 'пажња';
  } else if (date == '6/7/2026') {
    text = 'ждрал';
  } else if (date == '7/7/2026') {
    text = 'допис';
  } else if (date == '8/7/2026') {
    text = 'нагон';
  } else if (date == '9/7/2026') {
    text = 'косач';
  } else if (date == '10/7/2026') {
    text = 'оглед';
  } else if (date == '11/7/2026') {
    text = 'шунка';
  } else if (date == '12/7/2026') {
    text = 'злоба';
  } else if (date == '13/7/2026') {
    text = 'чукаљ';
  } else if (date == '14/7/2026') {
    text = 'шифра';
  } else if (date == '15/7/2026') {
    text = 'касир';
  } else if (date == '16/7/2026') {
    text = 'анекс';
  } else if (date == '17/7/2026') {
    text = 'коњак';
  } else if (date == '18/7/2026') {
    text = 'лавор';
  } else if (date == '19/7/2026') {
    text = 'неман';
  } else if (date == '20/7/2026') {
    text = 'ресор';
  } else if (date == '21/7/2026') {
    text = 'измет';
  } else if (date == '22/7/2026') {
    text = 'тезга';
  } else if (date == '23/7/2026') {
    text = 'покоп';
  } else if (date == '24/7/2026') {
    text = 'савет';
  } else if (date == '25/7/2026') {
    text = 'обала';
  } else if (date == '26/7/2026') {
    text = 'искра';
  } else if (date == '27/7/2026') {
    text = 'бомба';
  } else if (date == '28/7/2026') {
    text = 'песак';
  } else if (date == '29/7/2026') {
    text = 'торањ';
  } else if (date == '30/7/2026') {
    text = 'сонда';
  } else if (date == '31/7/2026') {
    text = 'играч';
  } else if (date == '1/8/2026') {
    text = 'жаока';
  } else if (date == '2/8/2026') {
    text = 'пуњач';
  } else if (date == '3/8/2026') {
    text = 'ћуран';
  } else if (date == '4/8/2026') {
    text = 'вагон';
  } else if (date == '5/8/2026') {
    text = 'глума';
  } else if (date == '6/8/2026') {
    text = 'ексер';
  } else if (date == '7/8/2026') {
    text = 'кусур';
  } else if (date == '8/8/2026') {
    text = 'кавга';
  } else if (date == '9/8/2026') {
    text = 'уклет';
  } else if (date == '10/8/2026') {
    text = 'мурал';
  } else if (date == '11/8/2026') {
    text = 'чочек';
  } else if (date == '12/8/2026') {
    text = 'цеста';
  } else if (date == '13/8/2026') {
    text = 'лепак';
  } else if (date == '14/8/2026') {
    text = 'пчела';
  } else if (date == '15/8/2026') {
    text = 'јасле';
  } else if (date == '16/8/2026') {
    text = 'пошта';
  } else if (date == '17/8/2026') {
    text = 'тикет';
  } else if (date == '18/8/2026') {
    text = 'лимар';
  } else if (date == '19/8/2026') {
    text = 'колач';
  } else if (date == '20/8/2026') {
    text = 'скроб';
  } else if (date == '21/8/2026') {
    text = 'шиљак';
  } else if (date == '22/8/2026') {
    text = 'кафић';
  } else if (date == '23/8/2026') {
    text = 'скала';
  } else if (date == '24/8/2026') {
    text = 'резон';
  } else if (date == '25/8/2026') {
    text = 'пајац';
  } else if (date == '26/8/2026') {
    text = 'сапун';
  } else if (date == '27/8/2026') {
    text = 'крпељ';
  } else if (date == '28/8/2026') {
    text = 'клада';
  } else if (date == '29/8/2026') {
    text = 'првак';
  } else if (date == '30/8/2026') {
    text = 'магла';
  } else if (date == '31/8/2026') {
    text = 'ћевап';
  } else if (date == '1/9/2026') {
    text = 'облак';
  } else if (date == '2/9/2026') {
    text = 'чучањ';
  } else if (date == '3/9/2026') {
    text = 'шапат';
  } else if (date == '4/9/2026') {
    text = 'котао';
  } else if (date == '5/9/2026') {
    text = 'нагао';
  } else if (date == '6/9/2026') {
    text = 'сврха';
  } else if (date == '7/9/2026') {
    text = 'тираж';
  } else if (date == '8/9/2026') {
    text = 'унука';
  } else if (date == '9/9/2026') {
    text = 'арома';
  } else if (date == '10/9/2026') {
    text = 'сласт';
  } else if (date == '11/9/2026') {
    text = 'екцем';
  } else if (date == '12/9/2026') {
    text = 'корак';
  } else if (date == '13/9/2026') {
    text = 'подне';
  } else if (date == '14/9/2026') {
    text = 'лекар';
  } else if (date == '15/9/2026') {
    text = 'талац';
  } else if (date == '16/9/2026') {
    text = 'салон';
  } else if (date == '17/9/2026') {
    text = 'север';
  } else if (date == '18/9/2026') {
    text = 'сомун';
  } else if (date == '19/9/2026') {
    text = 'стена';
  } else if (date == '20/9/2026') {
    text = 'смрад';
  } else if (date == '21/9/2026') {
    text = 'рвање';
  } else if (date == '22/9/2026') {
    text = 'занат';
  } else if (date == '23/9/2026') {
    text = 'ребус';
  } else if (date == '24/9/2026') {
    text = 'патња';
  } else if (date == '25/9/2026') {
    text = 'шетња';
  } else if (date == '26/9/2026') {
    text = 'сарма';
  } else if (date == '27/9/2026') {
    text = 'питон';
  } else if (date == '28/9/2026') {
    text = 'анјон';
  } else if (date == '29/9/2026') {
    text = 'свиња';
  } else if (date == '30/9/2026') {
    text = 'таван';
  } else if (date == '1/10/2026') {
    text = 'исход';
  } else if (date == '2/10/2026') {
    text = 'рецка';
  } else if (date == '3/10/2026') {
    text = 'марка';
  } else if (date == '4/10/2026') {
    text = 'поема';
  } else if (date == '5/10/2026') {
    text = 'плоча';
  } else if (date == '6/10/2026') {
    text = 'торзо';
  } else if (date == '7/10/2026') {
    text = 'умњак';
  } else if (date == '8/10/2026') {
    text = 'узрок';
  } else if (date == '9/10/2026') {
    text = 'метеж';
  } else if (date == '10/10/2026') {
    text = 'плажа';
  } else if (date == '11/10/2026') {
    text = 'спруд';
  } else if (date == '12/10/2026') {
    text = 'рунда';
  } else if (date == '13/10/2026') {
    text = 'такса';
  } else if (date == '14/10/2026') {
    text = 'узгој';
  } else if (date == '15/10/2026') {
    text = 'реума';
  } else if (date == '16/10/2026') {
    text = 'вотка';
  } else if (date == '17/10/2026') {
    text = 'темељ';
  } else if (date == '18/10/2026') {
    text = 'масло';
  } else if (date == '19/10/2026') {
    text = 'кобац';
  } else if (date == '20/10/2026') {
    text = 'шећер';
  } else if (date == '21/10/2026') {
    text = 'цигла';
  } else if (date == '22/10/2026') {
    text = 'машта';
  } else if (date == '23/10/2026') {
    text = 'кокос';
  } else if (date == '24/10/2026') {
    text = 'гњида';
  } else if (date == '25/10/2026') {
    text = 'циник';
  } else if (date == '26/10/2026') {
    text = 'залог';
  } else if (date == '27/10/2026') {
    text = 'пасаж';
  } else if (date == '28/10/2026') {
    text = 'пород';
  } else if (date == '29/10/2026') {
    text = 'шверц';
  } else if (date == '30/10/2026') {
    text = 'кловн';
  } else if (date == '31/10/2026') {
    text = 'зидар';
  } else if (date == '1/11/2026') {
    text = 'власт';
  } else if (date == '2/11/2026') {
    text = 'идеал';
  } else if (date == '3/11/2026') {
    text = 'љиљан';
  } else if (date == '4/11/2026') {
    text = 'замах';
  } else if (date == '5/11/2026') {
    text = 'табак';
  } else if (date == '6/11/2026') {
    text = 'сорта';
  } else if (date == '7/11/2026') {
    text = 'ливац';
  } else if (date == '8/11/2026') {
    text = 'сукоб';
  } else if (date == '9/11/2026') {
    text = 'анода';
  } else if (date == '10/11/2026') {
    text = 'терет';
  } else if (date == '11/11/2026') {
    text = 'кањон';
  } else if (date == '12/11/2026') {
    text = 'шаман';
  } else if (date == '13/11/2026') {
    text = 'легло';
  } else if (date == '14/11/2026') {
    text = 'сањар';
  } else if (date == '15/11/2026') {
    text = 'замор';
  } else if (date == '16/11/2026') {
    text = 'шљива';
  } else if (date == '17/11/2026') {
    text = 'сељак';
  } else if (date == '18/11/2026') {
    text = 'акорд';
  } else if (date == '19/11/2026') {
    text = 'зебра';
  } else if (date == '20/11/2026') {
    text = 'базен';
  } else if (date == '21/11/2026') {
    text = 'фарма';
  } else if (date == '22/11/2026') {
    text = 'убица';
  } else if (date == '23/11/2026') {
    text = 'салаш';
  } else if (date == '24/11/2026') {
    text = 'рабат';
  } else if (date == '25/11/2026') {
    text = 'зглоб';
  } else if (date == '26/11/2026') {
    text = 'трзај';
  } else if (date == '27/11/2026') {
    text = 'откуп';
  } else if (date == '28/11/2026') {
    text = 'жалба';
  } else if (date == '29/11/2026') {
    text = 'старт';
  } else if (date == '30/11/2026') {
    text = 'земља';
  } else if (date == '1/12/2026') {
    text = 'помпа';
  } else if (date == '2/12/2026') {
    text = 'ролат';
  } else if (date == '3/12/2026') {
    text = 'лидер';
  } else if (date == '4/12/2026') {
    text = 'понос';
  } else if (date == '5/12/2026') {
    text = 'напон';
  } else if (date == '6/12/2026') {
    text = 'појам';
  } else if (date == '7/12/2026') {
    text = 'рибар';
  } else if (date == '8/12/2026') {
    text = 'купус';
  } else if (date == '9/12/2026') {
    text = 'писар';
  } else if (date == '10/12/2026') {
    text = 'поука';
  } else if (date == '11/12/2026') {
    text = 'драма';
  } else if (date == '12/12/2026') {
    text = 'фењер';
  } else if (date == '13/12/2026') {
    text = 'поток';
  } else if (date == '14/12/2026') {
    text = 'тенор';
  } else if (date == '15/12/2026') {
    text = 'рељеф';
  } else if (date == '16/12/2026') {
    text = 'ирвас';
  } else if (date == '17/12/2026') {
    text = 'ризик';
  } else if (date == '18/12/2026') {
    text = 'племе';
  } else if (date == '19/12/2026') {
    text = 'клопа';
  } else if (date == '20/12/2026') {
    text = 'нехат';
  } else if (date == '21/12/2026') {
    text = 'житељ';
  } else if (date == '22/12/2026') {
    text = 'морка';
  } else if (date == '23/12/2026') {
    text = 'прасе';
  } else if (date == '24/12/2026') {
    text = 'деоба';
  } else if (date == '25/12/2026') {
    text = 'форма';
  } else if (date == '26/12/2026') {
    text = 'бараж';
  } else if (date == '27/12/2026') {
    text = 'штене';
  } else if (date == '28/12/2026') {
    text = 'јелка';
  } else if (date == '29/12/2026') {
    text = 'јарац';
  } else if (date == '30/12/2026') {
    text = 'писац';
  } else if (date == '31/12/2026') {
    text = 'лагер';
  } else if (date == '1/1/2027') {
    text = 'ланче';
  } else if (date == '2/1/2027') {
    text = 'метан';
  } else if (date == '3/1/2027') {
    text = 'плебс';
  } else if (date == '4/1/2027') {
    text = 'обука';
  } else if (date == '5/1/2027') {
    text = 'фитиљ';
  } else if (date == '6/1/2027') {
    text = 'кефир';
  } else if (date == '7/1/2027') {
    text = 'сабља';
  } else if (date == '8/1/2027') {
    text = 'згода';
  } else if (date == '9/1/2027') {
    text = 'сепса';
  } else if (date == '10/1/2027') {
    text = 'кајак';
  } else if (date == '11/1/2027') {
    text = 'тенис';
  } else if (date == '12/1/2027') {
    text = 'нотес';
  } else if (date == '13/1/2027') {
    text = 'пешак';
  } else if (date == '14/1/2027') {
    text = 'пуцањ';
  } else if (date == '15/1/2027') {
    text = 'сетва';
  } else if (date == '16/1/2027') {
    text = 'накит';
  } else if (date == '17/1/2027') {
    text = 'самит';
  } else if (date == '18/1/2027') {
    text = 'лонац';
  } else if (date == '19/1/2027') {
    text = 'курир';
  } else if (date == '20/1/2027') {
    text = 'пудер';
  } else if (date == '21/1/2027') {
    text = 'нанос';
  } else if (date == '22/1/2027') {
    text = 'сутра';
  } else if (date == '23/1/2027') {
    text = 'дечко';
  } else if (date == '24/1/2027') {
    text = 'браон';
  } else if (date == '25/1/2027') {
    text = 'џезва';
  } else if (date == '26/1/2027') {
    text = 'плашт';
  } else if (date == '27/1/2027') {
    text = 'сабор';
  } else if (date == '28/1/2027') {
    text = 'обест';
  } else if (date == '29/1/2027') {
    text = 'звоно';
  } else if (date == '30/1/2027') {
    text = 'модем';
  } else if (date == '31/1/2027') {
    text = 'рампа';
  } else if (date == '1/2/2027') {
    text = 'ткиво';
  } else if (date == '2/2/2027') {
    text = 'спрат';
  } else if (date == '3/2/2027') {
    text = 'изрез';
  } else if (date == '4/2/2027') {
    text = 'задах';
  } else if (date == '5/2/2027') {
    text = 'скела';
  } else if (date == '6/2/2027') {
    text = 'глина';
  } else if (date == '7/2/2027') {
    text = 'устав';
  } else if (date == '8/2/2027') {
    text = 'шљака';
  } else if (date == '9/2/2027') {
    text = 'тумач';
  } else if (date == '10/2/2027') {
    text = 'хељда';
  } else if (date == '11/2/2027') {
    text = 'пакла';
  } else if (date == '12/2/2027') {
    text = 'шутка';
  } else if (date == '13/2/2027') {
    text = 'чигра';
  } else if (date == '14/2/2027') {
    text = 'кичма';
  } else if (date == '15/2/2027') {
    text = 'ћошак';
  } else if (date == '16/2/2027') {
    text = 'петак';
  } else if (date == '17/2/2027') {
    text = 'залив';
  } else if (date == '18/2/2027') {
    text = 'торта';
  } else if (date == '19/2/2027') {
    text = 'тужба';
  } else if (date == '20/2/2027') {
    text = 'жабац';
  } else if (date == '21/2/2027') {
    text = 'навој';
  } else if (date == '22/2/2027') {
    text = 'ликер';
  } else if (date == '23/2/2027') {
    text = 'табла';
  } else if (date == '24/2/2027') {
    text = 'потез';
  } else if (date == '25/2/2027') {
    text = 'успон';
  } else if (date == '26/2/2027') {
    text = 'увала';
  } else if (date == '27/2/2027') {
    text = 'насад';
  } else if (date == '28/2/2027') {
    text = 'флуид';
  } else if (date == '1/3/2027') {
    text = 'тачка';
  } else if (date == '2/3/2027') {
    text = 'утаја';
  } else if (date == '3/3/2027') {
    text = 'корал';
  } else if (date == '4/3/2027') {
    text = 'мирис';
  } else if (date == '5/3/2027') {
    text = 'кварц';
  } else if (date == '6/3/2027') {
    text = 'курва';
  } else if (date == '7/3/2027') {
    text = 'мрмот';
  } else if (date == '8/3/2027') {
    text = 'талас';
  } else if (date == '9/3/2027') {
    text = 'хорда';
  } else if (date == '10/3/2027') {
    text = 'злато';
  } else if (date == '11/3/2027') {
    text = 'оклоп';
  } else if (date == '12/3/2027') {
    text = 'длака';
  } else if (date == '13/3/2027') {
    text = 'свила';
  } else if (date == '14/3/2027') {
    text = 'камин';
  } else if (date == '15/3/2027') {
    text = 'лебац';
  } else if (date == '16/3/2027') {
    text = 'самац';
  } else if (date == '17/3/2027') {
    text = 'стока';
  } else if (date == '18/3/2027') {
    text = 'пацка';
  } else if (date == '19/3/2027') {
    text = 'копча';
  } else if (date == '20/3/2027') {
    text = 'јахач';
  } else if (date == '21/3/2027') {
    text = 'љуска';
  } else if (date == '22/3/2027') {
    text = 'сутон';
  } else if (date == '23/3/2027') {
    text = 'лажов';
  } else if (date == '24/3/2027') {
    text = 'шнала';
  } else if (date == '25/3/2027') {
    text = 'ампер';
  } else if (date == '26/3/2027') {
    text = 'рулет';
  } else if (date == '27/3/2027') {
    text = 'фунта';
  } else if (date == '28/3/2027') {
    text = 'права';
  } else if (date == '29/3/2027') {
    text = 'запис';
  } else if (date == '30/3/2027') {
    text = 'здрав';
  } else if (date == '31/3/2027') {
    text = 'завод';
  } else if (date == '1/4/2027') {
    text = 'прија';
  } else if (date == '2/4/2027') {
    text = 'зачас';
  } else if (date == '3/4/2027') {
    text = 'олово';
  } else if (date == '4/4/2027') {
    text = 'салто';
  } else if (date == '5/4/2027') {
    text = 'ларва';
  } else if (date == '6/4/2027') {
    text = 'тепих';
  } else if (date == '7/4/2027') {
    text = 'кечап';
  } else if (date == '8/4/2027') {
    text = 'ролна';
  } else if (date == '9/4/2027') {
    text = 'оброк';
  } else if (date == '10/4/2027') {
    text = 'џокеј';
  } else if (date == '11/4/2027') {
    text = 'група';
  } else if (date == '12/4/2027') {
    text = 'слина';
  } else if (date == '13/4/2027') {
    text = 'фазон';
  } else if (date == '14/4/2027') {
    text = 'заова';
  } else if (date == '15/4/2027') {
    text = 'топуз';
  } else if (date == '16/4/2027') {
    text = 'силос';
  } else if (date == '17/4/2027') {
    text = 'чиода';
  } else if (date == '18/4/2027') {
    text = 'спреј';
  } else if (date == '19/4/2027') {
    text = 'идиот';
  } else if (date == '20/4/2027') {
    text = 'обиље';
  } else if (date == '21/4/2027') {
    text = 'журка';
  } else if (date == '22/4/2027') {
    text = 'напад';
  } else if (date == '23/4/2027') {
    text = 'птица';
  } else if (date == '24/4/2027') {
    text = 'арија';
  } else if (date == '25/4/2027') {
    text = 'флаша';
  } else if (date == '26/4/2027') {
    text = 'шпајз';
  } else if (date == '27/4/2027') {
    text = 'ретко';
  } else if (date == '28/4/2027') {
    text = 'расад';
  } else if (date == '29/4/2027') {
    text = 'момак';
  } else if (date == '30/4/2027') {
    text = 'нимфа';
  } else if (date == '1/5/2027') {
    text = 'кварт';
  } else if (date == '2/5/2027') {
    text = 'порта';
  } else if (date == '3/5/2027') {
    text = 'танге';
  } else if (date == '4/5/2027') {
    text = 'урбан';
  } else if (date == '5/5/2027') {
    text = 'ритам';
  } else if (date == '6/5/2027') {
    text = 'ратар';
  } else if (date == '7/5/2027') {
    text = 'серум';
  } else if (date == '8/5/2027') {
    text = 'одјек';
  } else if (date == '9/5/2027') {
    text = 'покер';
  } else {
    text = 'ништа';
  }

  return btoa(unescape(encodeURIComponent((text.toUpperCase()))))
}

const getTodaysDate = () => {
  const current = new Date();
  const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
  return date;
}





function App() {
  const initialStates = {
    answer: () => getRandomAnswer(),
    gameState: state.playing,
    gameShareState: state.notclicked,
    board: [
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
    ],
    cellStatuses: Array(6).fill(Array(5).fill(status.unguessed)),
    currentRow: 0,
    currentCol: 0,
    letterStatuses: () => {
      const letterStatuses = {}
      letters.forEach((letter) => {
        letterStatuses[letter] = status.unguessed
      })
      return letterStatuses
    },
    submittedInvalidWord: false,
    dateToday: () => getTodaysDate(),
  }

  const [answer, setAnswer] = useLocalStorage('stateAnswer', initialStates.answer())
  const [gameState, setGameState] = useLocalStorage('stateGameState', initialStates.gameState)
  const [board, setBoard] = useLocalStorage('stateBoard', initialStates.board)
  const [cellStatuses, setCellStatuses] = useLocalStorage('stateCellStatuses', initialStates.cellStatuses)
  const [currentRow, setCurrentRow] = useLocalStorage('stateCurrentRow', initialStates.currentRow)
  const [currentCol, setCurrentCol] = useLocalStorage('stateCurrentCol', initialStates.currentCol)
  const [letterStatuses, setLetterStatuses] = useLocalStorage('stateLetterStatuses', initialStates.letterStatuses())
  const [submittedInvalidWord, setSubmittedInvalidWord] = useLocalStorage('stateSubmittedInvalidWord', initialStates.submittedInvalidWord)
  const [dateToday, setDateToday] = useLocalStorage('stateDate', initialStates.dateToday)

  const [currentStreak, setCurrentStreak] = useLocalStorage('current-streak', 0)
  const [longestStreak, setLongestStreak] = useLocalStorage('longest-streak', 0)
  const [modalIsOpen, setIsOpen] = useState(false)
  const [firstTime, setFirstTime] = useLocalStorage('first-time', true)
  const [infoModalIsOpen, setInfoModalIsOpen] = useState(firstTime)
  const [settingsModalIsOpen, setSettingsModalIsOpen] = useState(false)

  const [playConfetti, setPlayConfetti] = useState(false)

  const openModal = () => setIsOpen(true)

  const handleInfoClose = () => {
    setFirstTime(false)
    setInfoModalIsOpen(false)
  }

  const handleEndGameClose = () => {
    setIsOpen(false)
    playAgain()
  }



  const check = () => {
    if (getTodaysDate() != dateToday) {
      playAgain();
    }

  }

  useEffect(() => {
    check()
  }, [initialStates])

  const [darkMode, setDarkMode] = useLocalStorage('dark-mode', false)
  const toggleDarkMode = () => setDarkMode((prev) => !prev)

  useEffect(() => {
    if (gameState !== state.playing) {
      setTimeout(() => {
        setPlayConfetti(false)
        openModal()
      }, 4500)

      setTimeout(() => {
        setPlayConfetti(true)
      }, 2500)

    }
  }, [gameState])



  const getCellStyles = (rowNumber, colNumber, letter) => {
    if (rowNumber === currentRow) {
      if (letter) {
        return `animate__animated animate__pulse animate__faster nm-inset-background dark:nm-inset-background-dark text-primary dark:text-primary-dark ${submittedInvalidWord ? 'border border-red-800' : ''
          }`
      }
      return 'nm-flat-background dark:nm-flat-background-dark text-primary dark:text-primary-dark'
    }

    var delay = ''
    if (rowNumber == currentRow - 1) {
      delay = 'delay-col-' + colNumber + ' '
    }

    switch (cellStatuses[rowNumber][colNumber]) {
      case status.green:
        return delay + 'nm-inset-n-green text-gray-50 animate__animated animate__flipInX'
      case status.yellow:
        return delay + 'nm-inset-yellow-500 text-gray-50 animate__animated animate__flipInX'
      case status.gray:
        return delay + 'nm-inset-n-gray text-gray-50 animate__animated animate__flipInX'
      default:
        return 'nm-flat-background dark:nm-flat-background-dark text-primary dark:text-primary-dark'
    }
  }


  const getDelay = (colNumber) => {
    return 'animationDelay:' + colNumber + 's '
  }



  const getCellStylesForSharing = (rowNumber, colNumber) => {
    switch (cellStatuses[rowNumber][colNumber]) {
      case status.green:
        return '🟢'
      case status.yellow:
        return '🟡'
      case status.gray:
        return '⚫'
      default:
        return 'nm-flat-background dark:nm-flat-background-dark text-primary dark:text-primary-dark'
    }
  }





  const addLetter = (letter) => {
    setSubmittedInvalidWord(false)
    setBoard((prev) => {
      if (currentCol > 4) {
        return prev
      }
      const newBoard = [...prev]
      newBoard[currentRow][currentCol] = letter
      return newBoard
    })
    if (currentCol < 5) {
      setCurrentCol((prev) => prev + 1)
    }
  }

  const addLetterEng = (letter) => {
    setSubmittedInvalidWord(false)
    setBoard((prev) => {
      if (currentCol > 4) {
        return prev
      }
      const newBoard = [...prev]
      newBoard[currentRow][currentCol] = letterEngToSrb(letter)
      return newBoard
    })
    if (currentCol < 5) {
      setCurrentCol((prev) => prev + 1)
    }
  }


  const letterEngToSrb = (letter) => {
    return letters_eng_srb[1][letters_eng_srb[0].indexOf(letter)];
  }


  const isValidWord = (word) => {
    if (word.length < 5) return false
    return words[word.toLowerCase()]
  }


  const onEnterPress = () => {
    const word = board[currentRow].join('')
    if (!isValidWord(word)) {
      setSubmittedInvalidWord(true)
      return
    }

    if (currentRow === 6) return

    updateCellStatuses(word, currentRow)
    updateLetterStatuses(word)
    setCurrentRow((prev) => prev + 1)
    setCurrentCol(0)
  }

  const onDeletePress = () => {
    setSubmittedInvalidWord(false)
    if (currentCol === 0) return

    setBoard((prev) => {
      const newBoard = [...prev]
      newBoard[currentRow][currentCol - 1] = ''
      return newBoard
    })

    setCurrentCol((prev) => prev - 1)
  }

  const updateCellStatuses = (word, rowNumber) => {
    setCellStatuses((prev) => {
      const newCellStatuses = [...prev]
      newCellStatuses[rowNumber] = [...prev[rowNumber]]
      const wordLength = word.length
      const answerLetters = decodeURIComponent(escape(window.atob((answer)))).split('')

      // set all to gray
      for (let i = 0; i < wordLength; i++) {
        newCellStatuses[rowNumber][i] = status.gray
      }

      // check greens
      for (let i = wordLength - 1; i >= 0; i--) {
        if (word[i] === decodeURIComponent(escape(window.atob(answer)))[i]) {
          newCellStatuses[rowNumber][i] = status.green
          answerLetters.splice(i, 1)
        }
      }

      // check yellows
      for (let i = 0; i < wordLength; i++) {
        if (answerLetters.includes(word[i]) && newCellStatuses[rowNumber][i] !== status.green) {
          newCellStatuses[rowNumber][i] = status.yellow
          answerLetters.splice(answerLetters.indexOf(word[i]), 1)
        }
      }

      return newCellStatuses
    })
  }

  const isRowAllGreen = (row) => {
    return row.every((cell) => cell === status.green)
  }

  // every time cellStatuses updates, check if the game is won or lost
  useEffect(() => {
    const cellStatusesCopy = [...cellStatuses]
    const reversedStatuses = cellStatusesCopy.reverse()
    const lastFilledRow = reversedStatuses.find((r) => {
      return r[0] !== status.unguessed
    })

    if (gameState === state.playing && lastFilledRow && isRowAllGreen(lastFilledRow)) {
      setGameState(state.won)

      //shareResult()

      var streak = currentStreak + 1
      setCurrentStreak(streak)
      setLongestStreak((prev) => streak > prev ? streak : prev)
    } else if (gameState === state.playing && currentRow === 6) {
      setGameState(state.lost)
      setCurrentStreak(0)
    }
  }, [
    cellStatuses, currentRow, gameState, setGameState,
    currentStreak, setCurrentStreak, setLongestStreak
  ])

  const updateLetterStatuses = (word) => {
    setLetterStatuses((prev) => {
      const newLetterStatuses = { ...prev }
      const wordLength = word.length
      for (let i = 0; i < wordLength; i++) {
        if (newLetterStatuses[word[i]] === status.green) continue

        if (word[i] === decodeURIComponent(escape(window.atob(answer)))[i]) {
          newLetterStatuses[word[i]] = status.green
        } else if (decodeURIComponent(escape(window.atob(answer))).includes(word[i])) {
          newLetterStatuses[word[i]] = status.yellow
        } else {
          newLetterStatuses[word[i]] = status.gray
        }
      }
      return newLetterStatuses
    })
  }


  const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }


  const playAgain = () => {

    // redirect to mobile if mobile and Android
    if (isMobile) {
      //console.log('mobile');
      //console.log(firstTime);
      if (firstTime) {
        let os = getMobileOperatingSystem();
        if (os == "Android") {
          window.location.replace("https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=pm.f2p.vordli");
        } else if (os == "iOS") {
          window.location.replace("https://apps.apple.com/us/app/vordli/id1613087917");
        } else if (os == "Windows Phone") {
          //window.location.href = "http://www.WindowsPhoneexample.com";
        } else {
          //window.location.href = "http://www.NowherLandexample.com";
        }
      }

    } else {
      //console.log('desktop');

    };
    //


    setDateToday(initialStates.dateToday)
    setAnswer(initialStates.answer())
    setGameState(initialStates.gameState)
    setBoard(initialStates.board)
    setCellStatuses(initialStates.cellStatuses)
    setCurrentRow(initialStates.currentRow)
    setCurrentCol(initialStates.currentCol)
    setLetterStatuses(initialStates.letterStatuses())
    setSubmittedInvalidWord(initialStates.submittedInvalidWord)


    //handleEndGameClose()
  }


  const shareResult = () => {
    const date = dateToday;

    var text = '';
    for (let i = 0; i < currentRow; i++) {
      for (let j = 0; j < 5; j++) {
        text += getCellStylesForSharing(i, j)
      }
      text += '\n';
    }


    const shareData = {
      title: 'Вордли',
      text: '\'Вордли - Погоди реч\' за ' + date + ': ' + currentRow + '/6\n' + text + '',
      url: ''
    }

    try {
      navigator.share(shareData)
      //sucess
    } catch (err) {
      var textField = document.createElement('textarea')
      textField.value = '\'Вордли - Погоди реч\' за ' + date + ': ' + currentRow + '/6\n' + text + 'vordli.com'


      document.body.appendChild(textField)
      textField.select()
      document.execCommand('copy')
      textField.remove()
    }




  }


  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: darkMode ? 'hsl(231, 16%, 25%)' : 'hsl(231, 16%, 92%)',
      zIndex: 99,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      height: 'calc(100% - 2rem)',
      width: 'calc(100% - 2rem)',
      backgroundColor: darkMode ? 'hsl(231, 16%, 25%)' : 'hsl(231, 16%, 92%)',
      boxShadow: `${darkMode
          ? '0.2em 0.2em calc(0.2em * 2) #252834, calc(0.2em * -1) calc(0.2em * -1) calc(0.2em * 2) #43475C'
          : '0.2em 0.2em calc(0.2em * 2) #A3A7BD, calc(0.2em * -1) calc(0.2em * -1) calc(0.2em * 2) #FFFFFF'
        }`,
      border: 'none',
      borderRadius: '1rem',
      maxWidth: '475px',
      maxHeight: '750px',
      position: 'relative',
    },
  }

  return (
    <div className={darkMode ? 'dark' : ''}>
      <div className={`flex flex-col justify-between h-fill bg-background dark:bg-background-dark`}>
        <header className="flex items-center py-2 px-3 text-primary dark:text-primary-dark">
          <button
            type="button"
            onClick={() => setSettingsModalIsOpen(true)}
            className="p-1 rounded-full"
          >
            <Settings />
          </button>



          <h1 className="flex-1 text-center text-xl xxs:text-2xl sm:text-4xl tracking-wide font-bold font-righteous animate__animated animate__slideInDown">
            <img src={logo} alt="logo" className="inline-flex items-center justify-center w-10 h-10 " /> ВОРДЛИ
          </h1>
          <button
            type="button"
            onClick={() => setInfoModalIsOpen(true)}
            className="p-1 rounded-full"
          >
            <Info />
          </button>
        </header>
        <div className="flex items-center flex-col py-3 flex-1 justify-center relative">
          <div className="relative">
            <div className="grid grid-cols-5 grid-flow-row gap-4">
              {board.map((row, rowNumber) =>
                row.map((letter, colNumber) => (
                  <span
                    key={colNumber}


                    className={`${getCellStyles(
                      rowNumber,
                      colNumber,
                      letter
                    )} inline-flex items-center font-medium justify-center text-lg w-[13vw] h-[13vw] xs:w-14 xs:h-14 sm:w-20 sm:h-20 rounded-full`}



                  >
                    {letter}
                  </span>
                ))
              )}
            </div>
            <div
              className={`absolute -bottom-24 left-1/2 transform -translate-x-1/2 ${gameState === state.playing ? 'hidden' : ''
                }`}
            >

              {/*



              <div className={darkMode ? 'dark' : ''}>
                <button
                  type="button"
                  className="rounded-lg z-10 px-6 py-2 text-lg nm-flat-background dark:nm-flat-background-dark hover:nm-inset-background dark:hover:nm-inset-background-dark text-primary dark:text-primary-dark"
                  onClick={playAgain}
                >
                  Покушај поново
                </button>
              </div>

              */}


            </div>
          </div>
          <Confetti active={playConfetti} config={confettiConfig} />
        </div>
        <InfoModal
          isOpen={infoModalIsOpen}
          handleClose={handleInfoClose}
          darkMode={darkMode}
          styles={modalStyles}
        />
        <EndGameModal
          isOpen={modalIsOpen}
          handleClose={handleEndGameClose}
          styles={modalStyles}
          darkMode={darkMode}
          gameState={gameState}
          state={state}
          currentStreak={currentStreak}
          longestStreak={longestStreak}
          answer={answer}
          playAgain={playAgain}
          shareResult={shareResult}
        />
        <SettingsModal
          isOpen={settingsModalIsOpen}
          handleClose={() =>
            setSettingsModalIsOpen(false)
          }
          styles={modalStyles}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
        />
        <div className={`h-auto pb-10 relative ${gameState === state.playing ? '' : 'delay-2600 animate__animated animate__zoomOutDown'}`}>
          <Keyboard
            letterStatuses={letterStatuses}
            addLetter={addLetter}
            onEnterPress={onEnterPress}
            onDeletePress={onDeletePress}
            gameDisabled={gameState !== state.playing}
            addLetterEng={addLetterEng}
          />
        </div>


      </div>

    </div>

  )
}

export default App
